import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/midautumn/index', method: 'GET', params }, { interceptResultCode: false });
};

// 点击预约
export const appointAPI = (params) => {
  return axios({ url: '/snail/midautumn/book', method: 'POST', params }, { interceptResultCode: false });
};

// 点击签到
export const signAPI = (params) => {
  return axios({ url: '/snail/midautumn/sign', method: 'POST', params }, { interceptResultCode: false });
};

// 免密登录
export const secretFreeLoginApi = (data) => {
  return axios({ url: '/cherry/auth/login', method: 'POST', data }, { interceptResultCode: false });
};

// 组队 初始化
export const teamInitAPI = (params) => {
  return axios({ url: '/snail/midautumn/team', method: 'GET', params }, { interceptResultCode: false });
};

// 组队 加入队伍
export const teamJoinAPI = (data) => {
  return axios({ url: '/snail/midautumn/team/entry', method: 'POST', data }, { interceptResultCode: false });
};

// 组队 踢出队伍
export const teamKickAPI = (data) => {
  return axios({ url: '/snail/midautumn/team/exit', method: 'POST', data }, { interceptResultCode: false });
};

// 组队 退出队伍
export const teamExitAPI = (data) => {
  return axios({ url: '/snail/midautumn/team/out', method: 'POST', data }, { interceptResultCode: false });
};

// 组队 领取奖励
export const teamRewardAPI = (params) => {
  return axios({ url: '/snail/midautumn/reward', method: 'POST', params }, { interceptResultCode: false });
};

// 获取服务器时间
export const onGetTimeAPI = (params) => {
  return axios({ url: '/snail/web-activity', method: 'GET', params }, { interceptResultCode: false });
};

export const downloadApps = (params) => {
  return axios(
    { url: "/jump/download/url", method: "POST", params },
    { interceptResultCode: false }
  );
};


// WEBPACK FOOTER //
// ./src/pages/snail/midAutumn/api.js